import { render, staticRenderFns } from "./BusinessMerchants.vue?vue&type=template&id=447f9714&scoped=true"
import script from "./BusinessMerchants.vue?vue&type=script&lang=ts"
export * from "./BusinessMerchants.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMerchants.vue?vue&type=style&index=0&id=447f9714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f9714",
  null
  
)

export default component.exports